module.exports = "<svg viewBox=\"0 0 299.2 112.3\"><path d=\"M30 18.9c6.1 0 11 5 11 11.1h18.9c.3-6.1 5.4-10.8 11.5-10.6 5.8.3 10.4 4.9 10.6 10.6h18.9C100.9 13.5 87.5.1 71 0c-7.6 0-15 2.9-20.5 8.1-12-11.3-31-10.8-42.3 1.3C2.9 15 0 22.3 0 30h18.9c0-6.1 4.9-11.1 11.1-11.1z\" class=\"st0\"></path><path d=\"M50.5 78.1L16.1 43.8 2.8 57.2l47.7 47.7 47.7-47.7-13.4-13.4-34.3 34.3z\" class=\"st0\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./svgs/icon-health.svg
// module id = 287
// module chunks = 1